import { render } from "./App.vue?vue&type=template&id=a10267a6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a10267a6&lang=css"
script.render = render

export default script